import { pyAPI } from 'constants/api';
import fetchApi from 'services/fetch';

const initialState = {
  isLoggedIn: false,
  channelConfigs: [],
};

export const auth = {
  state: { ...initialState },
  reducers: {
    updateLoggedInStatus(state, payload) {
      return {
        ...state,
        isLoggedIn: payload,
      };
    },
    updateChannelConfig(state, payload) {
      return {
        ...state,
        channelConfigs: payload,
      };
    },
  },
  effects: (dispatch) => {
    return {
      async checkMaintanence() {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'GET',
          url: pyAPI.maintenance,
          headers: {
            exclude: true,
            excludeRes: true,
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, result: response?.data });
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },
      async clearStore() {
        dispatch({ type: 'RESET_APP' });
      },
    };
  },
};
